import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-75">
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full md:w-1/2 space-y-6" data-id="element-77">
          <h2 className="font-handwriting text-4xl md:text-5xl leading-tight text-brown-dark" data-id="element-78">
            "Monatelang jeden Morgen dasselbe Drama – bis ich das endlich
            ausprobiert habe"
          </h2>
          <p className="font-serif text-lg md:text-xl leading-relaxed text-brown-dark/80" data-id="element-79">
            Wie ich Bellas chronischen Durchfall in den Griff bekommen habe –
            ohne Chemie, ohne teure Tierarztbesuche.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="w-full md:w-1/2" data-id="element-80">
          <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white transform rotate-2" data-id="element-81">
            <img src="https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=1200&q=80" alt="Bella – ein glücklicher Golden Retriever" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-82" />
          </div>
        </motion.div>
      </div>
    </section>;
}